import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { HardwareSlug } from '../../utils/enums';
import { useAuth } from '../../hooks/auth';
import { ToolCard, ToolsGrid } from './styles';

import imageFuzzyBitsLocked from '../../assets/images/card-fuzzy-start-gray.jpg';
import imageFuzzyBitsUnlocked from '../../assets/images/card-fuzzy-start-color.jpg';
import imageMicroBitLocked from '../../assets/images/card-microbit-gray-700x420px.png';
import imageMicroBitUnlocked from '../../assets/images/card-microbit-color-700x420px.png';
import imageFuzzyBoTlocked from '../../assets/images/image-fuzzy-bot-locked-1.jpg';
import imageFuzzyBoTUnlocked from '../../assets/images/image-bot-unlocked.jpg';
import imageSmartMakers1Locked from '../../assets/images/smart-makers-anos-iniciais-gray.jpg';
import imageSmartMakers1Unlocked from '../../assets/images/smart-makers-anos-iniciais.jpg';
import imageSmartMakers2Locked from '../../assets/images/smart-makers-anos-finais-gray.jpg';
import imageSmartMakers2Unlocked from '../../assets/images/smart-makers-anos-finais-blue.jpg';
import imageFuzzyPlusLocked from '../../assets/images/card-fuzzy-plus-gray.jpg';
import imageFuzzyPlusUnlocked from '../../assets/images/card-fuzzy-plus-color.jpg';
import { PadlockClose, PadlockOpen } from '../../assets/svg/SVGComponents';
import AddHardwareUnlockModal from '../../modals/AddHardwareUnlockModal';
import { useModal } from '../../hooks/modal';

const GridHardware: React.FC = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const { handleModal } = useModal();
  const handleStatusHardware = useCallback(
    (SlugHardware: HardwareSlug): boolean => {
      if (user.hardwares) {
        const unlockHardwares = user.hardwares.find(
          hardware => hardware.slug === SlugHardware,
        );
        if (unlockHardwares) {
          return true; // unlock
        }
      }
      return false; // locked
    },
    [user.hardwares],
  );

  const handleHardwareUnlockButton = useCallback(() => {
    handleModal(<AddHardwareUnlockModal />);
  }, [handleModal]);
  return (
    <ToolsGrid id="hardware-grid">
      <ToolCard
        to={
          handleStatusHardware(HardwareSlug.FUZZYBITS)
            ? `/hardwares/profile/fuzzy_bits`
            : `${pathname}`
        }
        className="item-1"
        background={
          handleStatusHardware(HardwareSlug.FUZZYBITS)
            ? imageFuzzyBitsUnlocked
            : imageFuzzyBitsLocked
        }
      >
        <span>Fuzzy Start</span>
        <p>
          {handleStatusHardware(HardwareSlug.FUZZYBITS) ? (
            <PadlockOpen fill="none" width="1.5rem" />
          ) : (
            <PadlockClose fill="#fff" width="1.5rem" />
          )}
        </p>
      </ToolCard>
      <ToolCard
        to={
          handleStatusHardware(HardwareSlug.FUZZYPLUS)
            ? `/hardwares/profile/fuzzy_bits_plus`
            : `${pathname}`
        }
        className="item-2"
        background={
          handleStatusHardware(HardwareSlug.FUZZYPLUS)
            ? imageFuzzyPlusUnlocked
            : imageFuzzyPlusLocked
        }
      >
        <span>Fuzzy Plus+</span>
        <p>
          {handleStatusHardware(HardwareSlug.FUZZYPLUS) ? (
            <PadlockOpen fill="none" width="1.5rem" />
          ) : (
            <PadlockClose fill="#fff" width="1.5rem" />
          )}
        </p>
      </ToolCard>
      <ToolCard
        to={
          handleStatusHardware(HardwareSlug.SMARTMAKERS_1)
            ? `/hardwares/profile/smart_makers_1`
            : `${pathname}`
        }
        className="item-4"
        background={
          handleStatusHardware(HardwareSlug.SMARTMAKERS_1)
            ? imageSmartMakers1Unlocked
            : imageSmartMakers1Locked
        }
      >
        <span>Smart¹</span>
        <p>
          {handleStatusHardware(HardwareSlug.SMARTMAKERS_1) ? (
            <PadlockOpen fill="none" width="1.5rem" />
          ) : (
            <PadlockClose fill="#fff" width="1.5rem" />
          )}
        </p>
      </ToolCard>

      <ToolCard
        to={
          handleStatusHardware(HardwareSlug.MICROBIT)
            ? `/hardwares/profile/micro_bit`
            : `${pathname}`
        }
        className="item-3"
        background={
          handleStatusHardware(HardwareSlug.MICROBIT)
            ? imageMicroBitUnlocked
            : imageMicroBitLocked
        }
      >
        <span>Micro:bit</span>
        <p>
          {handleStatusHardware(HardwareSlug.MICROBIT) ? (
            <PadlockOpen fill="none" width="1.22rem" />
          ) : (
            <PadlockClose fill="#fff" width="1.22rem" />
          )}
        </p>
      </ToolCard>
      <ToolCard
        to={
          handleStatusHardware(HardwareSlug.SMARTMAKERS_2)
            ? `/hardwares/profile/smart_makers_2`
            : `${pathname}`
        }
        className="item-5"
        background={
          handleStatusHardware(HardwareSlug.SMARTMAKERS_2)
            ? imageSmartMakers2Unlocked
            : imageSmartMakers2Locked
        }
      >
        <span>Smart²</span>
        <p>
          {handleStatusHardware(HardwareSlug.SMARTMAKERS_2) ? (
            <PadlockOpen fill="none" width="1.22rem" />
          ) : (
            <PadlockClose fill="#fff" width="1.22rem" />
          )}
        </p>
      </ToolCard>
      <ToolCard
        to={
          handleStatusHardware(HardwareSlug.FUZZYBOT)
            ? `/hardwares/profile/fuzzy_bot`
            : `${pathname}`
        }
        className="item-6"
        background={
          handleStatusHardware(HardwareSlug.FUZZYBOT)
            ? imageFuzzyBoTUnlocked
            : imageFuzzyBoTlocked
        }
      >
        <span>Fuzzy BoT</span>
        <p>
          {handleStatusHardware(HardwareSlug.FUZZYBOT) ? (
            <PadlockOpen fill="none" width="1.22rem" />
          ) : (
            <PadlockClose fill="#fff" width="1.22rem" />
          )}
        </p>
      </ToolCard>
    </ToolsGrid>
  );
};

export default GridHardware;
